// extracted by mini-css-extract-plugin
module.exports = {"headline":"lqgCFC","withSubtotalTitle":"L8Lh1x","totals":"uzbgvO","divider":"sRIWuY"};